// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const renderFunctionGrid = (...args: any[]) => (window as any).renderFunctionGrid(...args);


// ============================================================
// Dashboard · 商务风版本（去 Hero 渐变 / 白底 / 极简卡片）
// ============================================================

window.Pages = window.Pages || {};

Pages.dashboard = function () {
  const role = MOCK.ROLES[MOCK.SESSION.currentRole];
  const visibleGames = MOCK.GAMES.filter((g) => g.status === "active");
  const total = visibleGames.reduce(
    (acc, g) => {
      acc.share += g.today.share;
      acc.click += g.today.click;
      acc.install += g.today.install;
      acc.purchase += g.today.purchase;
      acc.revenue += g.revenue;
      return acc;
    },
    { share: 0, click: 0, install: 0, purchase: 0, revenue: 0 },
  );

  PageHooks.mounted = () => {
    // 趋势图
    const el = document.getElementById("dashboard-chart");
    if (el) {
      const chart = echarts.init(el);
      chart.setOption({
        grid: { top: 30, right: 16, bottom: 30, left: 50 },
        tooltip: UI.chartTooltip(),
        legend: {
          data: ["分享", "点击", "安装", "付费"],
          right: 0, top: 0,
          textStyle: { color: "#64748B", fontSize: 12 },
          itemWidth: 10, itemHeight: 10, itemGap: 14, icon: "rect",
        },
        xAxis: UI.chartXAxis(MOCK.TREND_DATA.dates),
        yAxis: UI.chartYAxis(),
        series: [
          UI.chartLineSeries("分享", MOCK.TREND_DATA.share,    { color: "#1E3A8A", area: true }),
          UI.chartLineSeries("点击", MOCK.TREND_DATA.click,    { color: "#475569" }),
          UI.chartLineSeries("安装", MOCK.TREND_DATA.install,  { color: "#0F766E" }),
          UI.chartLineSeries("付费", MOCK.TREND_DATA.purchase, { color: "#B45309" }),
        ],
      });
      window.addEventListener("resize", () => chart.resize());
    }

    // 渠道贡献环图
    const el2 = document.getElementById("dashboard-channel-pie");
    if (el2) {
      const chart2 = echarts.init(el2);
      const data = MOCK.CHANNEL_COMPARE.slice(0, 6);
      chart2.setOption({
        tooltip: { ...UI.chartTooltip(), trigger: "item", formatter: "{b}<br/>分享 <b>{c}</b> · {d}%" },
        legend: {
          orient: "vertical", right: 4, top: "center",
          textStyle: { color: "#64748B", fontSize: 11 },
          itemGap: 10, itemWidth: 8, itemHeight: 8, icon: "rect",
        },
        series: [
          {
            type: "pie",
            radius: ["55%", "75%"],
            center: ["38%", "50%"],
            avoidLabelOverlap: true,
            itemStyle: { borderColor: "#fff", borderWidth: 2 },
            label: {
              show: true, position: "center",
              formatter: () => `{a|总分享}\n{b|${UI.fmtNum(data.reduce((a,b)=>a+b.share,0))}}`,
              rich: {
                a: { color: "#94A3B8", fontSize: 11 },
                b: { color: "#0F172A", fontSize: 20, fontWeight: 600, padding: [4, 0, 0, 0] },
              },
            },
            labelLine: { show: false },
            data: data.map((c, i) => ({
              name: c.name,
              value: c.share,
              itemStyle: { color: UI.BUSINESS_COLORS[i] },
            })),
          },
        ],
      });
      window.addEventListener("resize", () => chart2.resize());
    }
  };

  return `
    <!-- 极简顶部 -->
    <div class="mb-5 flex items-end justify-between pb-4 border-b border-ink-200">
      <div>
        <div class="text-xs text-ink-500 mb-1">${getGreeting()}，${role.user}</div>
        <h1 class="text-[22px] font-semibold text-ink-900 tracking-tight">Dashboard</h1>
        <p class="text-[13px] text-ink-500 mt-1">当前管理 <span class="num font-semibold text-ink-900">${visibleGames.length}</span> 款游戏 · <span class="num font-semibold text-ink-900">${MOCK.PACKAGES.length}</span> 个包体 · 接入 <span class="num font-semibold text-ink-900">${MOCK.CHANNELS.filter((c) => c.enabled).length}</span> 个海外社交渠道</p>
      </div>
      <div class="flex items-center gap-2">
        ${UI.ghostBtn("查看周报", { icon: "fileText" })}
        ${UI.ghostBtn("数据导出", { icon: "download", onclick: "navigate('/ops/analytics/export')" })}
      </div>
    </div>

    <!-- KPI 卡（极简版） -->
    <div class="grid grid-cols-5 gap-3 mb-5">
      ${UI.statCard({ label: "今日分享次数", value: UI.fmtNum(total.share),    delta: 12,  icon: "share",        color: "brand" })}
      ${UI.statCard({ label: "今日点击次数", value: UI.fmtNum(total.click),    delta: 8,   icon: "mousePointer", color: "blue" })}
      ${UI.statCard({ label: "今日新增安装", value: UI.fmtNum(total.install),  delta: -3,  icon: "download",     color: "green" })}
      ${UI.statCard({ label: "今日新增付费", value: UI.fmtNum(total.purchase), delta: 25,  icon: "dollar",       color: "amber" })}
      ${UI.statCard({ label: "今日总收入",   value: UI.fmtMoney(total.revenue), delta: 18, icon: "trendingUp",   color: "ok" })}
    </div>

    <!-- 趋势 + 渠道贡献 -->
    <div class="grid grid-cols-3 gap-3 mb-5">
      <div class="col-span-2 card p-5">
        <div class="flex items-center justify-between mb-3">
          <div>
            <h3 class="text-[13px] font-semibold text-ink-900">数据趋势</h3>
            <p class="text-[11px] text-ink-500 mt-0.5">所有有权限的游戏聚合 · 最近 14 天</p>
          </div>
          <div class="flex items-center gap-1 text-xs p-0.5 bg-ink-100 rounded-md">
            <button class="px-2.5 py-1 rounded text-ink-500 hover:bg-white">7 天</button>
            <button class="px-2.5 py-1 rounded bg-white text-ink-900 font-medium shadow-card">14 天</button>
            <button class="px-2.5 py-1 rounded text-ink-500 hover:bg-white">30 天</button>
          </div>
        </div>
        <div id="dashboard-chart" style="height: 300px;"></div>
      </div>

      <div class="card p-5">
        <h3 class="text-[13px] font-semibold text-ink-900">渠道分享贡献</h3>
        <p class="text-[11px] text-ink-500 mt-0.5">Top 6 海外社交渠道</p>
        <div id="dashboard-channel-pie" style="height: 290px;" class="mt-2"></div>
      </div>
    </div>

    <!-- 功能全景（仅 SDK 管理员） -->
    ${renderFunctionGrid()}

    <!-- 团队接入的游戏 -->
    <div class="card mb-5">
      <div class="flex items-center justify-between px-5 py-4 border-b border-ink-200">
        <div>
          <h3 class="text-[13px] font-semibold text-ink-900">团队接入的游戏</h3>
          <p class="text-[11px] text-ink-500 mt-0.5">点击进入游戏详情；快捷操作直达分享配置 / 数据</p>
        </div>
        ${UI.hasPerm("dev_tools") ? UI.primaryBtn("新增游戏", { onclick: "navigate('/dev/games/create')", icon: "plus" }) : ""}
      </div>
      <div class="divide-y divide-ink-100">
        ${visibleGames.map(renderGameRow).join("")}
      </div>
    </div>

    <!-- 待办 / 通知 / 团队活动 -->
    <div class="grid grid-cols-3 gap-3 mb-5">
      ${renderTodoCard()}
      ${renderNotifCard()}
      ${renderTeamCard()}
    </div>
  `;
};

// ---------- 游戏行（替换原卡片网格，更紧凑商务） ----------
function renderGameRow(g) {
  return `
    <a href="#/dev/games/${g.id}" class="flex items-center gap-4 px-5 py-3.5 hover:bg-ink-50 group">
      <div class="w-10 h-10 rounded-lg bg-ink-50 border border-ink-200 flex items-center justify-center text-xl flex-shrink-0">${g.icon}</div>

      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
          <span class="text-sm font-semibold text-ink-900 group-hover:text-brand-700">${g.name}</span>
          ${UI.statusBadge(g.status)}
          <span class="text-[11px] text-ink-400">${g.category} · ${g.packages} 个包体</span>
        </div>
        <div class="text-[11px] text-ink-400 mt-0.5 font-mono">${g.code}</div>
      </div>

      <div class="grid grid-cols-4 gap-6 flex-shrink-0">
        ${gameRowMetric("今日分享", UI.fmtNum(g.today.share))}
        ${gameRowMetric("安装", UI.fmtNum(g.today.install))}
        ${gameRowMetric("转化率", g.convert + "%", "text-ok-700")}
        ${gameRowMetric("今日收入", UI.fmtMoney(g.revenue), "text-warn-700")}
      </div>

      <span class="text-ink-300 group-hover:text-brand-700 group-hover:translate-x-0.5 transition">${Icon.chevronRight({ size: 16 })}</span>
    </a>
  `;
}
function gameRowMetric(label, value, cls = "text-ink-900") {
  return `<div class="text-right">
    <div class="text-[10px] text-ink-400">${label}</div>
    <div class="num text-sm font-semibold ${cls} mt-0.5">${value}</div>
  </div>`;
}

// ---------- 待办 ----------
function renderTodoCard() {
  const todos = [
    { title: "TankBlitz 待上线", desc: "首个包体尚未创建", link: "/dev/games", urgent: true },
    { title: "JP-iOS 配置审核", desc: "新增包体待发布配置", link: "/ops/share-config" },
    { title: "查看周报", desc: "上周数据汇总已就绪", link: "/ops/analytics" },
  ];
  return `
    <div class="card p-4">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-[13px] font-semibold text-ink-900 flex items-center gap-1.5">
          ${Icon.flag({ size: 14, color: "#475569" })}
          我的待办
        </h3>
        <span class="badge bg-ink-100 text-ink-700">${todos.length}</span>
      </div>
      <div class="-mx-2">
        ${todos.map(t => `
          <a href="#${t.link}" class="block px-2 py-2 rounded-md hover:bg-ink-50 group">
            <div class="flex items-start gap-2.5">
              <span class="dot mt-1.5 ${t.urgent ? "bg-danger-500" : "bg-warn-500"}"></span>
              <div class="flex-1 min-w-0">
                <div class="text-[13px] font-medium text-ink-900 group-hover:text-brand-700">${t.title}</div>
                <div class="text-[11px] text-ink-500 mt-0.5">${t.desc}</div>
              </div>
              <span class="text-ink-300 group-hover:text-brand-700">${Icon.chevronRight({ size: 14 })}</span>
            </div>
          </a>
        `).join("")}
      </div>
    </div>
  `;
}

// ---------- 通知 ----------
function renderNotifCard() {
  return `
    <div class="card p-4">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-[13px] font-semibold text-ink-900 flex items-center gap-1.5">
          ${Icon.bell({ size: 14, color: "#475569" })}
          系统通知
        </h3>
        <button class="text-[11px] text-brand-700 hover:underline font-medium">全部</button>
      </div>
      <div class="-mx-2 divide-y divide-ink-100">
        ${MOCK.NOTIFICATIONS.slice(0, 3).map(n => `
          <div class="flex gap-2.5 cursor-pointer hover:bg-ink-50 px-2 py-2.5">
            <span class="dot mt-1.5 ${n.type === "alert" ? "bg-danger-500" : n.type === "warning" ? "bg-warn-500" : "bg-brand-500"}"></span>
            <div class="flex-1 min-w-0">
              <div class="text-[13px] font-medium text-ink-900 truncate">${n.title}</div>
              <div class="text-[11px] text-ink-500 mt-0.5 line-clamp-2">${n.desc}</div>
              <div class="text-[10px] text-ink-400 mt-1">${n.time}</div>
            </div>
          </div>
        `).join("")}
      </div>
    </div>
  `;
}

// ---------- 团队动态 ----------
function renderTeamCard() {
  return `
    <div class="card p-4">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-[13px] font-semibold text-ink-900 flex items-center gap-1.5">
          ${Icon.users({ size: 14, color: "#475569" })}
          团队最近活动
        </h3>
      </div>
      <div class="-mx-2 divide-y divide-ink-100">
        ${MOCK.AUDIT_LOGS.slice(0, 4).map((l) => `
          <div class="flex gap-2.5 px-2 py-2">
            <div class="w-7 h-7 rounded-md bg-ink-100 border border-ink-200 flex items-center justify-center text-ink-700 text-[11px] font-semibold flex-shrink-0">${l.user[0]}</div>
            <div class="flex-1 min-w-0">
              <div class="text-[12px] text-ink-900 truncate"><strong>${l.user}</strong> <span class="text-ink-500">${l.action}</span></div>
              <div class="text-[10px] text-ink-500 mt-0.5 truncate">${l.target}</div>
              <div class="text-[10px] text-ink-400 mt-0.5 num">${l.time.split(" ")[1]}</div>
            </div>
          </div>
        `).join("")}
      </div>
    </div>
  `;
}

function getGreeting() {
  const h = new Date().getHours();
  if (h < 6) return "凌晨好";
  if (h < 12) return "早上好";
  if (h < 14) return "中午好";
  if (h < 18) return "下午好";
  return "晚上好";
}

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).gameRowMetric = gameRowMetric;
;(window as any).getGreeting = getGreeting;
;(window as any).renderGameRow = renderGameRow;
;(window as any).renderNotifCard = renderNotifCard;
;(window as any).renderTeamCard = renderTeamCard;
;(window as any).renderTodoCard = renderTodoCard;
